import React from 'react';
import Tooltip from 'jl-design-system/components/tooltip/Tooltip';

import styles from './email-signup.scss';

const DisclaimerTooltip = () => (
  <div className={styles.tooltip}>
    <Tooltip
      icon="Info"
      anchor="left"
      id="signupTooltip"
      verticalAnchor="bottom"
      buttonLabel="What will I receive?"
    >
      We&#39;ll send you updates on new arrivals, inspiration, offers &amp; promotional events.
    </Tooltip>
  </div>
);

export default DisclaimerTooltip;
